import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Grid,
  IconButton,
  InputLabel,
  Stack,
  Typography,
} from '@mui/material';
import { isNull, isString, map, size } from 'lodash';

import { Props } from './props';
const FormDisplayRendererView: React.FC<Props> = (props) => {
  const {
    schema,
    sectionHeaderProps,
    sectionContainerProps,
    headerContainerProps,
    itemContainerProps,
    itemContentContainerProps,
    titleProps,
    valueProps,
    ...restProps
  } = props;

  const renderSectionTitle = (item) => {
    if (isString(item?.headerTitle))
      return (
        <Typography
          {...sectionHeaderProps}
          {...item?.sectionHeaderProps}
          sx={{
            fontSize: '1rem',
            fontWeight: 600,
            ...sectionHeaderProps?.sx,
            ...item?.sectionHeaderProps?.sx,
          }}
        >
          {item?.headerTitle}
        </Typography>
      );
    return item?.headerTitle;
  };

  const renderTitle = (i) => {
    if (isString(i?.title))
      return (
        <InputLabel
          {...titleProps}
          {...i?.titleProps}
          sx={{ ...titleProps?.sx, ...i?.titleProps?.sx }}
        >
          {i?.title}
        </InputLabel>
      );
    return i?.title;
  };
  const renderValue = (i) => {
    if (isString(i?.value)) {
      return (
        <Typography
          {...valueProps}
          {...i?.valueProps}
          sx={{
            fontWeight: 600,
            fontSize: '14px',
            ...valueProps?.sx,
            ...i?.valueProps?.sx,
          }}
        >
          {i.value}
        </Typography>
      );
    }
    return i?.value;
  };

  const renderSchema = () => {
    return map(schema, (item, i) => {
      if (isNull(item)) return item;
      const isLast = size(schema) - 1;
      return (
        <Box
          key={i}
          {...restProps}
          sx={{
            ...(isLast !== i && !item?.disableBorder && { borderBottom: 1 }),
            borderColor: '#E5E5E5',
            paddingBlock: '1.5rem',
            ...restProps?.sx,
          }}
        >
          <Box {...headerContainerProps} {...item?.headerContainerProps}>
            {item?.headerTitle && renderSectionTitle(item)}
            {item?.sectionEdit && (
              <IconButton {...item?.sectionEdit?.sectionEditButtonProps}>
                {item?.sectionEdit?.icon ?? <EditIcon />}
              </IconButton>
            )}
          </Box>
          <Grid
            container
            spacing={2}
            direction="row"
            // for global and local props purpose
            {...sectionContainerProps}
            {...item?.sectionContainerProps}
          >
            {map(item?.list, (i, index) => {
              return (
                <Grid
                  item
                  key={index}
                  xs={i?.mobileColSpan ?? 12}
                  md={i?.colSpan ?? 12}
                  {...itemContainerProps}
                  {...i?.itemContainerProps}
                >
                  <Stack
                    direction={'column'}
                    gap={5}
                    {...itemContentContainerProps}
                    {...i?.itemContentContainerProps}
                  >
                    {i?.title && renderTitle(i)}
                    {i?.value && renderValue(i)}
                  </Stack>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      );
    });
  };

  return <React.Fragment>{renderSchema()}</React.Fragment>;
};

export type FormDisplayRendererProps = Props;
export const FormDisplayRenderer = FormDisplayRendererView;
export default FormDisplayRendererView;
